/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemDateInputLimitRelativeAllOf } from './formPagePropertyItemDateInputLimitRelativeAllOf';


/**
 * 年月日型の入力制限の相対指定を表す。
 */
export interface FormPagePropertyItemDateInputLimitRelative { 
    /**
    * 入力制限が有効かどうか
    */
    enabled: boolean;
    limitType: 'relative';
    /**
    * 過去 or 今後。 true なら過去、false なら今後
    */
    before: boolean;
    /**
    * 以内 or (以前 or 以降)。  true なら フォーム当日 〜 指定された入力制限から算出する日付以内 を許可 false なら指定された入力制限から算出する日付以前 or 以降( before が true なら以前。false なら以降) 
    */
    within: boolean;
    /**
    * 入力制限の値
    */
    limitValue: number;
    /**
    * 入力制限の年月週日の単位
    */
    limitUnit: FormPagePropertyItemDateInputLimitRelative.LimitUnitEnum;
}

export namespace FormPagePropertyItemDateInputLimitRelative {
    export type LimitUnitEnum = 'year' | 'month' | 'week' | 'day';
    export const LimitUnitEnum = {
        Year: 'year' as LimitUnitEnum,
        Month: 'month' as LimitUnitEnum,
        Week: 'week' as LimitUnitEnum,
        Day: 'day' as LimitUnitEnum
    };
}


